export default {
  root: ({ instance }) => {
    const size = instance?.$attrs?.["size"] || "sm";
    return {
      class: [
        "p-tag",
        {
          "p-tag_sm": size === "sm",
          "p-tag_md": size === "md",
          "p-tag_lg": size === "lg",
        },
      ],
    };
  },
};
